angular
  .module 'filters'
  .filter 'padStart', ->
    (number, size) ->
      sign = if Math.sign(number) is -1 then '-' else ''
      sign + new Array(size).concat([Math.abs(number)]).join('0').slice(-size)
